import { Navigate, useParams } from 'react-router-dom';
import { IndustryPreviewVisual } from '@/modules/marketing/components/industry-visuals';
import { MarketingDetailPage } from '@/modules/marketing/components/marketing-detail-page';
import { PRICINGCRM_FEATURES } from '@/modules/marketing/components/pricingcrm-content';
import { PRODUCTS } from '@/modules/marketing/components/product-visuals';
import { isMarketingOnlyDomain } from '@/modules/marketing/components/site-chrome';

export function ProductDetailPage() {
    const { slug } = useParams<{ slug: string }>();

    if (isMarketingOnlyDomain()) {
        const feature = PRICINGCRM_FEATURES.slice(0, 4).find((f) => f.slug === slug);
        if (!feature) return <Navigate to="/" replace />;

        return (
            <MarketingDetailPage
                backLabel="Products"
                backHref="/#products"
                visual={<IndustryPreviewVisual icon={feature.icon} size="lg" />}
                content={{
                    eyebrow: 'Product',
                    icon: feature.icon,
                    gradient: 'from-[#7f1d2e] to-[#e62b4a]',
                    title: feature.title,
                    tagline: feature.description,
                    description: feature.description,
                    bullets: [],
                }}
            />
        );
    }

    const product = PRODUCTS.find((p) => p.key === slug);

    if (!product) {
        return <Navigate to="/" replace />;
    }

    return (
        <MarketingDetailPage
            backLabel="Products"
            backHref="/#products"
            visual={product.visual}
            content={{
                eyebrow: product.eyebrow,
                icon: product.icon,
                gradient: product.gradient,
                title: product.title,
                tagline: product.description,
                description: product.longDescription,
                bullets: product.bullets,
            }}
        />
    );
}
